/* Black Forest: diagnostic events only; never completed purchases or customer data.
   Use the existing Clarity installation and respect Shopify processing permissions. */
(function () {
  'use strict';
  if (window.__bffClarityEventsV1) return;
  var shopify = window.Shopify;
  var theme = shopify && shopify.theme;
  if (shopify && (shopify.designMode || (theme && theme.role && theme.role !== 'main'))) return;
  window.__bffClarityEventsV1 = true;
  var productViewSent = false;
  var privacyLoadRequested = false;

  function send(name) {
    // Fail closed while the permission API is unavailable. Never infer consent from a loaded tag.
    try {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (!privacy || typeof privacy.analyticsProcessingAllowed !== 'function') return false;
      if (privacy.analyticsProcessingAllowed() !== true || typeof window.clarity !== 'function') return false;
      window.clarity('event', name);
      return true;
    } catch (error) {
      // Only isolate this optional analytics call; do not suppress storefront errors.
      return false;
    }
  }

  function productView() {
    if (productViewSent || document.visibilityState === 'hidden') return;
    if (!document.body || !document.body.hasAttribute('data-product-id')) return;
    productViewSent = send('bff_product_page_view');
  }

  function loadPrivacyApi() {
    var api = window.Shopify;
    if (!api || api.customerPrivacy || privacyLoadRequested || typeof api.loadFeatures !== 'function') return;
    privacyLoadRequested = true;
    try {
      api.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], function (error) {
        if (!error) productView();
      });
    } catch (error) {
      // No consent changes, no analytics queue and no interruption to ordering.
    }
  }

  document.addEventListener('product-ajax:added', function (event) {
    var product = event.detail && event.detail.product;
    if (!product || product.status || !(Number(product.id || product.variant_id) > 0) || !(Number(product.quantity) > 0)) return;
    send('bff_add_to_cart_success');
  });
  document.addEventListener('product-ajax:error', function () { send('bff_add_to_cart_error'); });
  document.addEventListener('bff:extras:added', function () { send('bff_extras_added'); });
  document.addEventListener('bff:extras:error', function () { send('bff_extras_error'); });
  document.addEventListener('visitorConsentCollected', productView);
  document.addEventListener('visibilitychange', productView);
  window.addEventListener('pageshow', productView);

  function ready() {
    loadPrivacyApi();
    productView();
    // A finite set of retries accommodates the existing async tag without permanent polling.
    [500, 1000, 2000, 4000, 8000].forEach(function (delay) {
      window.setTimeout(function () { loadPrivacyApi(); productView(); }, delay);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once: true});
  else ready();
})();
